const module = { name: 'discovery/moviesByAllZipCodes/moviesByAllZipCodes.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



import { default as pagination } from 'swug-fdRequire-call:desktop/shared/pagination';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);
function run() {
    checkDependencies(module.name, debugLog);
    pagination.attach({ bypassClientLoading: true });
}
run();
export default module.exports;